// Copyright (c) Move Closer 2022.

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const ARTICLE_CARD_COMPONENT_KEY = 'ArticleCardComponent'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const DEFAULT_BUTTON_VARIANT = 'outline'
